module.exports = new __parcel__URL__("manage-global-fields.6322527f.gif").toString();